export * from './delivery';
export * from './visual';
export * from './productInfoSection';
export * from './productSeeDescription';
export * from './ratingsAndReviews';
export * from './information';
export * from './ProductDetailContainerSection';
export * from './productRecommendations';
export * from './banners';
export * from './providers';
export * from './dataLayerProductDetail';
